import React from 'react';
import Select from 'components/shared/select';

const SelectWorkspace = ({ workspaces, onChange }) => {
  return (
    <div>
      <label htmlFor="workspaceId" className="LessonCreationModal-inputTitle">
        {t('workspaces.workspace')}
      </label>
      <Select name="workspaceId" id="workspaceId" onChange={onChange} fullWidth>
        {workspaces.map(workspace => (
          <option
            key={`${workspace.name}-${workspace.id}`}
            value={workspace.id || ''}
          >
            {workspace.name}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default SelectWorkspace;
